/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.services {
    declare var turf: any;
    declare var Terraformer: any;

    export class GisMapService {

        private layerDictionary: any = {};
        private featureLayer: L.GeoJSON;

        constructor(private $q: angular.IQService,
            private esriMapService: services.EsriMapService,
            private jsonDictionaryStoreService: services.JsonDictionaryStoreService,
            private growl: angular.growl.IGrowlService,
            private formDataService: services.FormDataService) {

        }

        public addFeaturesLayer(features: Wars.Domain.Model.Dtos.FeatureDto[], zoomToLayer?: boolean) {
            this.addFeaturesLayerInternal(features);

            if (zoomToLayer && this.featureLayer) {
                warsApp.directives.GisMapController.currentMap.fitBounds(this.featureLayer.getBounds());
            }
        }

        private removeFeatureLayer() {
            warsApp.directives.GisMapController.currentMap.removeLayer(this.featureLayer);
        }

        private addFeaturesLayerInternal(features: Wars.Domain.Model.Dtos.FeatureDto[]) {
            if (!features || features.length === 0)
                return;

            let newFeatureCollection = {
                features: Enumerable.from(features).select(f => JSON.parse(f.geoJson)).toArray(),
                type: "FeatureCollection"
            };

            //var x = Enumerable.from(features).select(f => JSON.parse(f.geoJson)).toArray();

            this.featureLayer =
                new L.GeoJSON(<any>newFeatureCollection).addTo(warsApp.directives.GisMapController.currentMap);
        }

        private runPostWorkflowActions(clearLayers: boolean, runGuid: string) {
            if (clearLayers) {
                this.layerDictionary[runGuid].forEach(l => {
                    warsApp.directives.GisMapController.currentMap.removeLayer(l);
                });
            }

            delete this.layerDictionary[runGuid];
        }

        public runGisActionWorkflowOverride(override: Wars.Domain.Model.Gis.GisActionWorkflowOverride,
            process: Wars.Domain.Model.Dtos.ProcessDto,
            formId: string,
            formDataId: any) {

            const runGuid: string = services.UtilityService.generateGuidComb();

            let promise = this.runWorkflow(override.gisActionWorkflowConfiguration, process.id, runGuid);

            promise.then(r => {
                if (r && r.exitWorkflow) {
                    this.runPostWorkflowActions(override.gisActionWorkflowConfiguration.clearAllLayersAtCompletion,
                        runGuid);
                    if (override.postRunGisActionWorkflowOverride) {
                        this.runGisActionWorkflowOverride(override.postRunGisActionWorkflowOverride,
                            process,
                            formId,
                            formDataId);
                    }
                } else if (override.fieldMappings && override.fieldMappings.length > 0) {
                    let features: any = r[override.featureListOutput_id];
                    let featureOutput: any = null;

                    if (features.features) {
                        features = features.features;
                    }

                    if (!features) {
                        return;
                    }

                    if (override.featureOutput_id) {
                        featureOutput = r[override.featureOutput_id][0];
                        process.features.push(featureOutput);
                        process.featureToRows[featureOutput.id] = [];
                        this.addFeaturesLayer([featureOutput], false);
                    } else {
                        this.addFeaturesLayer(features, false);
                    }

                    let processRowsToAdd = [];
                    var featureActionsRun = 0;

                    features.forEach(feature => {
                        let rowId: string;

                        Elp.Api.Process.addRow(process.id,
                            formId,
                            formDataId,
                            override.formSection.objectSchema.uniqueIdentifier,
                            override.isAddReadOnly).then(r => {
                            rowId = r;

                            let saveDto: Wars.Domain.Model.Dtos.MultiAddFieldsSaveDto = <any>{
                                FieldValues: {
                                }
                            };

                            let processRow = { id: rowId };

                            override.fieldMappings.forEach(f => {
                                let value: any = "";

                                if (override.featureListOutput.type ===
                                    Wars.Domain.Model.Codes.Enums.GisInputOutputType.ListofGisDatastoreFeatures) {

                                    value = feature["metadata" + f.metadataPosition];
                                    if (value == "True") {
                                        value = true;
                                    }
                                } else if (override.featureListOutput.type ===
                                    Wars.Domain.Model.Codes.Enums.GisInputOutputType.FeatureCollection) {
                                    if (f.propertyName && f.propertyName != "") {
                                        value = feature.properties[f.propertyName];
                                    } else if (f.metadataPosition && featureOutput) {
                                        value = featureOutput["metadata" + f.metadataPosition];
                                    }
                                }

                                processRow[f.field.schemaProperty.uniqueIdentifier] = value;
                                let metadata = "";

                                if (f.isReadOnly) {
                                    if (!process.rowMetadata) {
                                        (<any>process).rowMetadata = {};
                                    }

                                    //[f.field.schemaProperty.uniqueIdentifier]
                                    if (!process.rowMetadata[rowId]) {
                                        process.rowMetadata[rowId] = {
                                            fieldsMetadata: {}
                                        };
                                    }

                                    metadata = JSON.stringify({
                                        isReadonly: true
                                    });

                                    (<any>process.rowMetadata[rowId]).fieldsMetadata[f.field.schemaProperty
                                        .uniqueIdentifier] = metadata;
                                }

                                (<any>saveDto).FieldValues[f.field.schemaProperty.uniqueIdentifier] = {
                                    Value: value,
                                    Metadata: metadata
                                };
                            });

                            processRowsToAdd.push(processRow);

                            this.formDataService.setMultipleListFields(process.id,
                                formId,
                                formDataId,
                                override.formSection.objectSchema.uniqueIdentifier,
                                rowId,
                                saveDto).then(r => {
                                featureActionsRun++;
                                if (features.length * 2 === featureActionsRun) {
                                    processRowsToAdd.forEach(processRow => {
                                        if (!(<any>process.formJson[formId][formDataId][override.formSection.objectSchema.uniqueIdentifier])) {
                                            (<any>process.formJson[formId])[formDataId][override.formSection.objectSchema.uniqueIdentifier] = [];
                                        }
                                        (<any>process.formJson[formId][formDataId][override.formSection.objectSchema.uniqueIdentifier]).push(processRow);
                                    });
                                }
                            });

                            processRow[override.featureField.schemaProperty.uniqueIdentifier] = featureOutput ? featureOutput.id : feature.id;
                            Elp.Api.Process.setRowValue(process.id,
                                formId,
                                formDataId,
                                override.formSection.objectSchema.uniqueIdentifier,
                                override.featureField.schemaProperty.uniqueIdentifier,
                                rowId,
                                featureOutput ? featureOutput.id : feature.id,
                                true).then(r => {
                                featureActionsRun++;
                                if (features.length * 2 === featureActionsRun) {
                                    processRowsToAdd.forEach(processRow => {
                                        if (!(<any>process.formJson[formId][formDataId][override.formSection.objectSchema.uniqueIdentifier])) {
                                            (<any>process.formJson[formId])[formDataId][override.formSection.objectSchema.uniqueIdentifier] = [];
                                        }
                                        (<any>process.formJson[formId][formDataId][override.formSection.objectSchema.uniqueIdentifier]).push(processRow);
                                    });
                                }
                            });

                            if (!featureOutput) {
                                process.features.push(feature);
                                process.featureToRows[feature.id] = [rowId];
                            } else {
                                (<any>process.featureToRows[featureOutput.id]).push(rowId);
                            }
                        });


                    });

                    this.runPostWorkflowActions(override.gisActionWorkflowConfiguration.clearAllLayersAtCompletion,
                        runGuid);

                    if (override.postRunGisActionWorkflowOverride) {
                        this.runGisActionWorkflowOverride(override.postRunGisActionWorkflowOverride,
                            process,
                            formId,
                            formDataId);
                    }
                } else {
                    if (override.postRunGisActionWorkflowOverride) {
                        this.runGisActionWorkflowOverride(override.postRunGisActionWorkflowOverride,
                            process,
                            formId,
                            formDataId);
                    }
                }
            });
        }

        public runWorkflow(workflow: Wars.Domain.Model.Gis.GisActionWorkflowConfiguration,
            processId: string,
            runGuid: string): angular.IPromise<any> {
            var d = this.$q.defer();

            if (workflow) {
                this.layerDictionary[runGuid] = [];

                const orderedActions = Enumerable.from(workflow.gisActionBlocks).orderBy(w => w.workflowOrder)
                    .toArray();

                let promise = this.runActionPromise(orderedActions[0],
                    null,
                    orderedActions.slice(1),
                    processId,
                    runGuid);

                promise.then(r => {
                    d.resolve(r);
                });
            } else {
                d.reject();
            }

            return d.promise;
        }

        private runActionPromise(action: Wars.Domain.Model.Gis.GisActionBlock,
                input: any,
                nextActions: Array<any>,
                processId: string,
                runGuid: string):
            angular.IPromise<any> {

            const outterD = this.$q.defer();
            const innerD = this.$q.defer();

            let outputs = [];

            switch (action.gisActionBlockType) {
            case Wars.Domain.Model.Codes.Enums.GisActionBlockType.AddFeature:
                this.runAddFeaturesAction(action, input, processId, runGuid).then(g => {

                    let output = this.getOutputs(action, g, input);
                    innerD.resolve(output);
                });

                break;
            case Wars.Domain.Model.Codes.Enums.GisActionBlockType.DrawFeature:
                this.runDrawFeatureAction(action, input, processId, runGuid).then(g => {

                    let output = this.getOutputs(action, g, input);
                    innerD.resolve(output);
                });

                break;
            case Wars.Domain.Model.Codes.Enums.GisActionBlockType.QueryEsriQuery:
                this.runEsriQueryAction(action, input, processId, runGuid).then(r => {

                    let output = this.getOutputs(action, r, input);
                    innerD.resolve(output);
                });

                break;
            case Wars.Domain.Model.Codes.Enums.GisActionBlockType.QueryGisDatastore:
                break;
            case Wars.Domain.Model.Codes.Enums.GisActionBlockType.Filter:
                this.runFilterAction(action, input, processId, runGuid).then(g => {

                    let output = this.getOutputs(action, g, input);
                    innerD.resolve(output);
                });
                break;
            case Wars.Domain.Model.Codes.Enums.GisActionBlockType.Trim:
                this.runTrimAction(action, input, processId, runGuid).then(g => {

                    let output = this.getOutputs(action, g, input);
                    innerD.resolve(output);
                });
                break;
            case Wars.Domain.Model.Codes.Enums.GisActionBlockType.Validation:
                this.runValidationAction(action, input, processId, runGuid).then(g => {

                    if (action.gisActionValidationConfiguration.exitWorkflowOnFailure && !g) {
                        innerD.resolve({ exitWorkflow: true });
                    } else {
                        let output = this.getOutputs(action, g, input);
                        innerD.resolve(output);
                    }
                });
                break;
            case Wars.Domain.Model.Codes.Enums.GisActionBlockType.SetProperty:
                this.runSetPropertyAction(action, input, processId, runGuid).then(g => {

                    let output = this.getOutputs(action, g, input);
                    innerD.resolve(output);
                });
                break;
            case Wars.Domain.Model.Codes.Enums.GisActionBlockType.BufferGeometry:
                this.runBufferAction(action, input, processId, runGuid).then(g => {

                    let output = this.getOutputs(action, g, input);
                    innerD.resolve(output);
                });
                break;
            }

            innerD.promise.then(r => {
                if (r && (<any>r).exitWorkflow) {
                    outterD.resolve(r);
                } else if (nextActions && nextActions.length > 0) {
                    this.runActionPromise(nextActions[0], r, nextActions.slice(1), processId, runGuid).then(
                        actionResult => {
                            outterD.resolve(actionResult);

                        });
                } else {
                    outterD.resolve(r);
                }

            });

            return outterD.promise;
        }

        private runFilterAction(actionBlock: Wars.Domain.Model.Gis.GisActionBlock,
            inputs: any,
            processId: string,
            runGuid: string): angular.IPromise<any> {
            const d = this.$q.defer();

            let featureCollection = null;

            if (actionBlock.filterFeatureCollectionConfiguration.featureCollectionInput) {
                if (inputs[actionBlock.filterFeatureCollectionConfiguration.featureCollectionInput.relatedGisInputOutput
                    .id]) {
                    featureCollection = inputs[actionBlock.filterFeatureCollectionConfiguration.featureCollectionInput
                        .relatedGisInputOutput.id];
                }
            }

            if (actionBlock.filterFeatureCollectionConfiguration.useFilterFunction) {
                //TODO: Implement this if I need it later
            } else {
                let filteredFeatures = featureCollection.features;
                actionBlock.filterFeatureCollectionConfiguration.filterAttributes.forEach(attr => {
                    filteredFeatures = filteredFeatures.filter(f => {
                        const value = f.properties[attr.attributeName];

                        switch (attr.compareOperator) {
                        case Wars.Domain.Model.Codes.Enums.CompareOperator.Equals:
                            return value == attr.value;
                        case Wars.Domain.Model.Codes.Enums.CompareOperator.GreaterThan:
                            return value > attr.value;
                        case Wars.Domain.Model.Codes.Enums.CompareOperator.GreaterThanOrEqualTo:
                            return value >= attr.value;
                        case Wars.Domain.Model.Codes.Enums.CompareOperator.LessThan:
                            return value < attr.value;
                        case Wars.Domain.Model.Codes.Enums.CompareOperator.LessThanOrEqualTo:
                            return value <= attr.value;
                        case Wars.Domain.Model.Codes.Enums.CompareOperator.NotEquals:
                            return value != attr.value;

                        default:
                            return false;
                        }
                    });
                });

                const result = {
                    type: "FeatureCollection",
                    features: filteredFeatures
                };

                d.resolve(result);
            }

            return d.promise;
        }

        private runSetPropertyAction(actionBlock: Wars.Domain.Model.Gis.GisActionBlock,
            inputs: any,
            processId: string,
            runGuid: string): angular.IPromise<any> {
            const d = this.$q.defer();

            let featureCollection = null;

            if (actionBlock.setPropertyConfiguration.propertyCollection) {
                if (inputs[actionBlock.setPropertyConfiguration.propertyCollection.relatedGisInputOutput.id]) {
                    featureCollection = inputs[actionBlock.setPropertyConfiguration.propertyCollection
                        .relatedGisInputOutput.id];
                }
            }

            if (featureCollection && featureCollection.features && featureCollection.features.length > 0) {
                featureCollection.features.forEach(f => {
                    if (actionBlock.setPropertyConfiguration.useJsonDictionaryStore) {
                        if (actionBlock.setPropertyConfiguration.jsonDictionaryOperationType ===
                            Wars.Domain.Model.Codes.Enums.JsonDictionaryOperationType.ContainsKey) {
                            f.properties[actionBlock.setPropertyConfiguration.propertyName] =
                                this.jsonDictionaryStoreService.containsKey(
                                    actionBlock.setPropertyConfiguration.jsonDictionaryStore,
                                    f.properties[actionBlock.setPropertyConfiguration.comparisionProperty]);

                        } else if (actionBlock.setPropertyConfiguration.jsonDictionaryOperationType ===
                            Wars.Domain.Model.Codes.Enums.JsonDictionaryOperationType.GetValue) {
                            f.properties[actionBlock.setPropertyConfiguration.propertyName] =
                                this.jsonDictionaryStoreService.getValue(
                                    actionBlock.setPropertyConfiguration.jsonDictionaryStore,
                                    f.properties[actionBlock.setPropertyConfiguration.comparisionProperty]);

                        }
                    }
                    if (actionBlock.setPropertyConfiguration.useJavascriptTransformer) {
                        //TODO: Implement this if later needed
                    }
                });
            }

            d.resolve(featureCollection);

            return d.promise;
        }

        private runValidationAction(actionBlock: Wars.Domain.Model.Gis.GisActionBlock,
            inputs: any,
            processId: string,
            runGuid: string): angular.IPromise<any> {
            const d = this.$q.defer();

            let featureCollection = null;

            if (actionBlock.gisActionValidationConfiguration.validationCollection) {
                if (inputs[actionBlock.gisActionValidationConfiguration.validationCollection.relatedGisInputOutput
                    .id]) {
                    featureCollection = inputs[actionBlock.gisActionValidationConfiguration.validationCollection
                        .relatedGisInputOutput.id];
                }
            }

            if (actionBlock.gisActionValidationConfiguration.checkAnyFeatures) {
                if (featureCollection && featureCollection.features && featureCollection.features.length > 0) {
                    d.resolve(true);
                } else {
                    this.growl.error(actionBlock.gisActionValidationConfiguration.validationMessage, { ttl: 10000 });
                    d.resolve(false);
                }
            } else {
                //TODO: Add the javascript way here when needed
            }

            return d.promise;
        }

        private runEsriQueryAction(actionBlock: Wars.Domain.Model.Gis.GisActionBlock,
                inputs: any,
                processId: string,
                runGuid: string): angular.
            IPromise<any> {
            const d = this.$q.defer();

            let geometry = null;

            if (actionBlock.gisActionBlockEsriQueryConfiguration.geometryFilterValueInput) {
                if (inputs[actionBlock.gisActionBlockEsriQueryConfiguration.geometryFilterValueInput
                    .relatedGisInputOutput.id]) {
                    geometry = inputs[actionBlock.gisActionBlockEsriQueryConfiguration.geometryFilterValueInput
                        .relatedGisInputOutput.id];
                }
            }

            this.esriMapService.queryMapService(actionBlock.gisActionBlockEsriQueryConfiguration.esriQueryConfiguration,
                null,
                geometry).then(r => {
                d.resolve(r);
            });

            return d.promise;
        }

        private runBufferAction(actionBlock: Wars.Domain.Model.Gis.GisActionBlock,
            inputs: any,
            processId: string,
            runGuid: string): angular.IPromise<any> {
            const d = this.$q.defer();

            let geometry = null;

            if (actionBlock.bufferConfiguration.geometryToBuffer) {
                if (inputs[actionBlock.bufferConfiguration.geometryToBuffer.relatedGisInputOutput.id]) {
                    var tempGeometry = inputs[actionBlock.bufferConfiguration.geometryToBuffer.relatedGisInputOutput
                        .id];
                    geometry = this.getFeatureFromGeometry(tempGeometry);
                }
            }

            var buffered = turf.buffer(geometry, actionBlock.bufferConfiguration.bufferDistance, 'meters');
            if (actionBlock.bufferConfiguration.showBuffer) {
                var bufferLayer = new L.GeoJSON(<any>buffered).addTo(warsApp.directives.GisMapController.currentMap);
                this.layerDictionary[runGuid].push(bufferLayer);
            }

            d.resolve(buffered);

            return d.promise;
        }

        private getFeatureFromGeometry(geometry) {
            let type = "Point";
            let coordinates = null;

            if (geometry._latlng) {
                type = "Point";
                coordinates = [geometry._latlng.lng, geometry._latlng.lat];
            } else {
                //TODO: Fix this someday
            }

            let feature = {
                type: "Feature",
                properties: {},
                geometry: {
                    type: type,
                    coordinates: coordinates
                }
            };

            return feature;
        }

        private getOutputs(actionBlock: Wars.Domain.Model.Gis.GisActionBlock, result: any, input: any): any {
            let outputProperty = Enumerable.from(actionBlock.outputCollection.gisInputOutputs)
                .single(i => !i.relatedGisInputOutput_id);

            let returnObj = {};

            returnObj[outputProperty.id] = result;

            Enumerable.from(actionBlock.outputCollection.gisInputOutputs).where(g => g.relatedGisInputOutput_id != null)
                .forEach(g => {
                    if (g.relatedGisInputOutput.relatedGisInputOutput) {
                        returnObj[g.id] = input[g.relatedGisInputOutput.relatedGisInputOutput.id];
                    } else {
                        returnObj[g.id] = input[g.relatedGisInputOutput_id];
                    }
                });

            return returnObj;
        }

        private runTrimAction(actionBlock: Wars.Domain.Model.Gis.GisActionBlock,
            inputs: any,
            processId: string,
            runGuid: string): angular.IPromise<any> {
            const d = this.$q.defer();

            let geo = inputs[actionBlock.trimConfiguration.comparisionGeometry.relatedGisInputOutput_id];
            geo = geo.toGeoJSON();

            let bbox;
            if (geo && geo.geometry.type === "LineString") {
                geo = turf.buffer(geo.geometry, 25, 'meters');
                bbox = turf.bbox(geo);
            } else {
                let clippingGeometry = geo.getBounds();

                bbox = [
                    clippingGeometry._southWest.lng, clippingGeometry._southWest.lat,
                    clippingGeometry._northEast.lng, clippingGeometry._northEast.lat
                ];
            }

            let featureCollection = null;

            if (actionBlock.trimConfiguration.featureCollection) {
                if (inputs[actionBlock.trimConfiguration.featureCollection.relatedGisInputOutput.id]) {
                    featureCollection = inputs[actionBlock.trimConfiguration.featureCollection.relatedGisInputOutput
                        .id];
                }
            }

            featureCollection.features.forEach(f => {
                var originalFeature = f;

                var originalDistance = turf.lineDistance(originalFeature, 'miles');
                let clippedFeature = warsApp.bboxClip.bboxClip(f, bbox);

                let clippedDistance = turf.lineDistance(clippedFeature, 'miles');

                var differences = this.getLineDifferences(originalFeature, clippedFeature);

                f.geometry = clippedFeature.geometry;

                actionBlock.trimConfiguration.lineTrimAttributes.forEach(attr => {
                    if (attr.isAdd) {
                        f.properties[attr.attributeName] = f.properties[attr.attributeName] + differences.beginDistance;
                    } else {
                        f.properties[attr.attributeName] = f.properties[attr.attributeName] - differences.endDistance;
                    }

                    //Hack: Remove and either add a round block or trim configuration
                    f.properties[attr.attributeName] = f.properties[attr.attributeName].toFixed(3);
                });
            });

            let layer = L.geoJSON(featureCollection);
            directives.GisMapController.currentMap.addLayer(layer);
            this.layerDictionary[runGuid].push(layer);

            d.resolve(featureCollection);

            return d.promise;
        }

        private getLineDifferences(feature: any, comparisionFeature: any) {
            let isBeginning = true;

            let beginningLine = {
                type: "Feature",
                geometry: {
                    type: "LineString",
                    coordinates: []
                }
            };

            let endingLine = {
                type: "Feature",
                geometry: {
                    type: "LineString",
                    coordinates: []
                }
            };

            var coordinates = feature.geometry.coordinates;
            var comparisionCoordinates = comparisionFeature.geometry.coordinates;

            let comparisionIndex = 0;

            for (let i = 0; i < coordinates.length; i++) {
                if (comparisionIndex < comparisionCoordinates.length &&
                    (coordinates[i][0] >= comparisionCoordinates[comparisionIndex][0] - 0.002 && coordinates[i][0] <= comparisionCoordinates[comparisionIndex][0] + 0.002) &&
                    (coordinates[i][1] >= comparisionCoordinates[comparisionIndex][1] - 0.002 && coordinates[i][1] <= comparisionCoordinates[comparisionIndex][1] + 0.002)) {
                    if (isBeginning) {
                        isBeginning = false;
                    }
                    comparisionIndex++;
                } else {
                    if (isBeginning) {
                        beginningLine.geometry.coordinates.push(coordinates[i]);
                    } else {
                        endingLine.geometry.coordinates.push(coordinates[i]);
                    }
                }
            }

            return {
                beginDistance: beginningLine.geometry.coordinates.length > 0
                    ? turf.lineDistance(beginningLine, 'miles')
                    : 0,
                endDistance: endingLine.geometry.coordinates.length > 0 ? turf.lineDistance(endingLine, 'miles') : 0
            }
        }

        private runAddFeaturesAction(actionBlock: Wars.Domain.Model.Gis.GisActionBlock,
                inputs: any,
                processId: string,
                runGuid: string): angular.
            IPromise<any> {
            const d = this.$q.defer();
            let featureCollection = null;
            let correlatedCollection = null;

            if (actionBlock.addFeaturesConfiguration.featureCollection) {
                if (inputs[actionBlock.addFeaturesConfiguration.featureCollection.relatedGisInputOutput.id]) {
                    featureCollection = inputs[actionBlock.addFeaturesConfiguration.featureCollection
                        .relatedGisInputOutput.id];

                    if (actionBlock.addFeaturesConfiguration.featureCollection.type ==
                        Wars.Domain.Model.Codes.Enums.GisInputOutputType.Geometry) {

                        featureCollection = {
                            features: [this.getFeatureFromGeometry(featureCollection)]
                        };
                    }
                }
            }

            if (actionBlock.addFeaturesConfiguration.correlatedCollection) {
                if (inputs[actionBlock.addFeaturesConfiguration.correlatedCollection.relatedGisInputOutput.id]) {
                    correlatedCollection = inputs[actionBlock.addFeaturesConfiguration.correlatedCollection
                        .relatedGisInputOutput.id];
                }
            }

            if (featureCollection && featureCollection.features && featureCollection.features.length > 0) {
                let features = [];

                let lastCorrelated = null;
                for (let i = 0; i < featureCollection.features.length; i++) {
                    let newFeature =
                        Elp.Api.GisDatastore.createFeatureFromGeoJson(
                            actionBlock.addFeaturesConfiguration.gisDatastore_id,
                            featureCollection.features[i]);

                    actionBlock.addFeaturesConfiguration.featureAttributeToPropertyMaps.forEach(fa => {
                        let value = "";
                        if (correlatedCollection && correlatedCollection.features) {
                            if (correlatedCollection.features[i]) {
                                value = correlatedCollection.features[i].properties[fa.propertyName];
                            } else if (lastCorrelated) {
                                value = lastCorrelated.properties[fa.propertyName];
                            }

                        } else {
                            value = featureCollection.features[i].properties[fa.propertyName];
                        }

                        if (fa.codeGroupToTransform) {
                            var code = Enumerable.from(fa.codeGroupToTransform.codes)
                                .firstOrDefault(s => s.longDescription == value);
                            if (code) {
                                value = code.uniqueIdentifier;
                            }
                        }
                        if (fa.javascriptTransformer) {
                            let args = ['value', fa.javascriptTransformer.code];
                            let myFunc = Function.apply(null, args);

                            value = myFunc(value);
                        }

                        if (fa.useGeometryLatitude) {
                            value = featureCollection.features[i].geometry.coordinates[0][1];
                        }
                        if (fa.useGeometryLongtitude) {
                            value = featureCollection.features[i].geometry.coordinates[0][0];
                        }

                        newFeature['metadata' + fa.attributeNumber] = value;
                        if (correlatedCollection) {
                            lastCorrelated = correlatedCollection.features[i];
                        }
                    });

                    newFeature.process_Id = processId;
                    features.push(newFeature);
                }

                Elp.Api.GisDatastore.saveFeatures(actionBlock.addFeaturesConfiguration.gisDatastore_id, features)
                    .then(savedFeatures => {
                        d.resolve(savedFeatures);
                    });
            } else {
                d.resolve([]);
            }

            return d.promise;
        }

        private runDrawFeatureAction(actionBlock: Wars.Domain.Model.Gis.GisActionBlock,
            inputs: any,
            processId: string,
            runGuid: string): angular.IPromise<any> {

            return this.drawFeatureAction(actionBlock.drawFeatureConfiguration, runGuid);
        }

        public drawFeatureAction(drawFeatureConfiguration: Wars.Domain.Model.Gis.DrawFeatureConfiguration,
            runGuid?: string): angular.IPromise<any> {
            const d = this.$q.defer();
            let geometry;

            switch (drawFeatureConfiguration.drawingType) {
            case Wars.Domain.Model.Codes.Enums.GeometryType.Point:
                geometry = (<any>directives.GisMapController.currentMap).editTools.startMarker();
                break;
            case Wars.Domain.Model.Codes.Enums.GeometryType.Polygon:
                geometry = (<any>directives.GisMapController.currentMap).editTools.startPolygon();
                break;
            case Wars.Domain.Model.Codes.Enums.GeometryType.MultiLineString:
                geometry = (<any>directives.GisMapController.currentMap).editTools.startPolyline();
                break;
            case Wars.Domain.Model.Codes.Enums.GeometryType.Rectangle:
                geometry = (<any>directives.GisMapController.currentMap).editTools.startRectangle();
                break;
            default:
                geometry = (<any>directives.GisMapController.currentMap).editTools.startPolyline();
                break;
            }

            let commitFunc = () => {
                geometry.editor.disable();
                (<any>directives.GisMapController.currentMap).editTools.off('editable:drawing:commit', commitFunc);

                if (runGuid) {
                    this.layerDictionary[runGuid].push(geometry);
                }

                if (drawFeatureConfiguration.clearDrawingAfterSelection) {
                    warsApp.directives.GisMapController.currentMap.removeLayer(geometry);
                }

                d.resolve(geometry);
            };

            (<any>directives.GisMapController.currentMap).editTools.on('editable:drawing:commit', commitFunc);

            return d.promise;
        }

        public zoomToFeature(featureId: string, process: Wars.Domain.Model.Dtos.ProcessDto) {
            var feature = Enumerable.from(process.features).singleOrDefault(f => f.id === featureId);

            if (feature) {
                var zoomLayer = new L.GeoJSON(JSON.parse(feature.geoJson));

                warsApp.directives.GisMapController.currentMap.fitBounds(zoomLayer.getBounds());

            }
        }

        public removeFeature(featureId: string, process: Wars.Domain.Model.Dtos.ProcessDto) {
            let feature = Enumerable.from(process.features).singleOrDefault(f => f.id === featureId);

            process.features.remove(feature);
            this.removeFeatureLayer();

            this.addFeaturesLayer(process.features);
        }
    }
}


warsApp.registerService('GisMapService',
    ['$q', 'esriMapService', 'jsonDictionaryStoreService', 'growl', 'formDataService']);